class SmoothAccordion extends HTMLElement {
  constructor() {
    super();
    this.detailsElements = Array.from(this.querySelectorAll('details'));
    
    this.detailsElements.forEach(details => {
      const summary = details.querySelector('summary');
      const content = details.querySelector('.accordion__content');
      
      details.animation = null;
      details.isClosing = false;
      details.isExpanding = false;

      summary.addEventListener('click', (e) => this.onClick(e, details, summary, content));
    });
  }

  onClick(e, details, summary, content) {
    e.preventDefault();
    details.style.overflow = 'hidden';

    // Exclusive Accordion: Close others
    this.detailsElements.forEach(otherDetails => {
      if (otherDetails !== details && otherDetails.open && !otherDetails.isClosing) {
        this.shrink(otherDetails, otherDetails.querySelector('summary'), otherDetails.querySelector('.accordion__content'));
      }
    });

    if (details.isClosing || !details.open) {
      this.open(details, summary, content);
    } else if (details.isExpanding || details.open) {
      this.shrink(details, summary, content);
    }
  }

  shrink(details, summary, content) {
    details.isClosing = true;
    const startHeight = `${details.offsetHeight}px`;
    const endHeight = `${summary.offsetHeight}px`;

    if (details.animation) {
      details.animation.cancel();
    }

    details.animation = details.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 300,
      easing: 'ease-out',
      fill: 'forwards'
    });

    const fadeAnim = content.animate({
      opacity: [1, 0]
    }, {
      duration: 250,
      easing: 'ease-out',
      fill: 'forwards'
    });

    details.animation.onfinish = () => {
      details.open = false;
      if (details.animation) details.animation.cancel();
      fadeAnim.cancel();
      details.animation = null;
      details.isClosing = false;
      details.style.height = details.style.overflow = '';
    };
    details.animation.oncancel = () => details.isClosing = false;
  }

  open(details, summary, content) {
    details.style.height = `${details.offsetHeight}px`;
    details.open = true;
    window.requestAnimationFrame(() => {
      details.isExpanding = true;
      const startHeight = `${details.offsetHeight}px`;
      const endHeight = `${summary.offsetHeight + content.offsetHeight}px`;

      if (details.animation) {
        details.animation.cancel();
      }

      details.animation = details.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 300,
        easing: 'ease-out',
        fill: 'forwards'
      });

      const fadeAnim = content.animate({
        opacity: [0, 1]
      }, {
        duration: 300,
        easing: 'ease-out',
        fill: 'forwards'
      });

      details.animation.onfinish = () => {
        details.open = true;
        if (details.animation) details.animation.cancel();
        fadeAnim.cancel();
        details.animation = null;
        details.isExpanding = false;
        details.style.height = details.style.overflow = '';
      };
      details.animation.oncancel = () => details.isExpanding = false;
    });
  }
}

customElements.define('smooth-accordion', SmoothAccordion);
